import React from "react";
import { Box, Typography } from "@mui/material";

const EmptySelection: React.FC = () => {
  return (
    <Box p={2}>
      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontSize: "0.82rem",
          color: "rgba(0,0,0,0.65)",
        }}
      >
        Aún no has seleccionado objetivos genéricos. Selecciona al menos uno en
        la columna izquierda.
      </Typography>
    </Box>
  );
};

export default EmptySelection;
